import { reactive } from 'vue'

const chatData = reactive({
    attendances: {progress: [], waiting: [], automation: [], closedDaily: []},
    attendanceActive: {},
    channels: [],
    clients: [],
    users: [],
    departaments: [],
    notifications: [],
    messagesFast: [], // Messages model
    messagesTemplates: [],
    messagesAutomatics: [],
    insertMessage: '',
    form: {textToSend: '', sendVoice: true, internalMessages: false},
    automations: {actions: []},
    selectedAttendances: {show: false, selected: []},
    configs: {},
    loading: {request: true, modal: false, type: '', title: '', content: ''},
    modal: {show: false, title: 'Título do modal', fixed: false, component: '', use: {}},
    websocket: {token: '', status: 'disconnected'},
    worker: null,
})

export { chatData }